import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { ModelList } from '../../../components/PaginatedList/ModelList';


// Redux
import { searchAlbum, restoreAlbum, createAlbum } from '../Album/redux/album.actions';
import { FullAlbums } from '../Album/redux/album.selectors';
import { FullLibraries } from './redux/library.selectors';
import { TERM_ALBUM_PLURAL, TERM_LIBRARY, hasAccess, useActiveItem } from '../../services/CaptureCollabService';
import { NewContent } from '../../../components/Content/NewContent';
import { SmartContainer } from '../../../styles/Containers';
import { AlbumList } from '../Album/AlbumList';
import { LibraryNavigation } from './LibraryNavigation';
import { useParams } from 'react-router-dom';
import { getLibrary } from './redux/library.actions';
import { Photostream } from '../Photostream/Photosteam';
import { StyledH3 } from '../../../styles/StyledHTML';
import { StyledButton } from '../../../styles/matieralui/Button';
import { Uploader } from '../Photostream/Uploader';
import { AssetsList } from '../Assets/AssetsList';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconSettings } from '../../Icons';
import { StyledFullScreenModal } from '../../components/Content/FullScreenModal';
import { AssetViewer } from '../Assets/AssetViewer';
import { Role } from '../../../redux/Auth/auth.selectors';
import { searchPermissions, useMyPermissions } from '../Permission/redux/permissions.actions';
import { NoPermissions } from '../Permission/NoPermissions';
import { PermissionsEditor } from '../Permission/PermissionsEditor';
import { FullPermissions } from '../Permission/redux/permissions.selectors';
import { RouteBreadCrumbs } from '../../../routes';
import { FullScreenLoader } from '../../components/Layout/FullScreenLoader';
import { TopLevelNavigation } from '../../components/Dashboard/TopLevelNavigation';

export const LibraryPage = () => {

    // New Modal
    const dispatch = useDispatch();
    const storeLibraries = FullLibraries();
    const { id, screen } = useParams();
    const [openViewer, setOpenViewer] = useState(false);
    const [activeAsset, setActiveAsset] = useState(null);
    const currentUserRole = Role();
    const { permissions, hasPermission, getPermissionRole, permissionChecked } = useMyPermissions();
    const [noAccess, setNoAccess] = useState(false);
    const [myRole, setMyRole] = useState(null);

    const [filters, setFilters] = useState(null);


    const { activeId, activeItem, activeModel, activeLoading } = useActiveItem({ id, model: 'Libary', selector: FullLibraries, getAction: getLibrary })

    // --------------------------
    // Effects
    // --------------------------
    // Get This Item
    useEffect(() => {
        // Set The Filters
        const args = { Library: `["${id}"]` }
        setFilters(args);
    }, [id]);

    // Check Permissions
    useEffect(() => {
        if (hasPermission('Library', id)) {
            const r = getPermissionRole('Library', id);
            setNoAccess(false);
            setMyRole(r);
        } else {
            setNoAccess(true);
        }

    }, [permissions])


    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => {
        dispatch(push(`/asset/${item.id}`))
        // setActiveAsset(item);
        // setOpenViewer(true);
    }

    // --------------------------
    // Renders
    // --------------------------
    const renderTopBarChildren = () => {

        if (noAccess) return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">

                {id && activeItem && (myRole === 'owner' || myRole === 'admin') && (
                    <PermissionsEditor
                        modelId={activeItem?.id}
                        model="Library"
                        selector={FullPermissions}
                        action={searchPermissions}
                    />
                )}
                {id && (myRole === 'owner' || myRole === 'admin') && (<StyledIconButton onClick={() => dispatch(push(`/library/${id}/settings`))}><IconSettings /></StyledIconButton>)}
                {myRole !== 'viewer' && (<StyledButton variant='contained' color="blue" onClick={() => dispatch(push(`/library/${id}/upload`))}>Upload</StyledButton>)}
            </SmartContainer>
        )

    }

    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
        // return (<LibraryNavigation libraryId={id} />)
    }

    // Render Page

    const title = (activeItem) ? `${activeItem?.name} Recent Photos` : 'Loading...';
    return (
        <App title={title} subtitle={TERM_LIBRARY}
            pageNavigation={renderPageNavigation}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={[RouteBreadCrumbs.libraries, { href: `/library/${id}/albums`, title: TERM_ALBUM_PLURAL }]}>
            {!activeItem && (<FullScreenLoader />)}
            {activeItem && (
                <SmartContainer width="100%">

                    {(!noAccess && permissionChecked !== 'notchecked') && (
                        <AssetsList 
                            onSelect={handleSelect}
                            filters={filters}
                            myRole={myRole}
                            sortByKey={`${id}SortLibrary`}
                            filterByDateKey={`${id}FilterDateLibrary`}
                            filterByTypeKey={`${id}FilterTypeLibrary`}
                        />
                    )}
                    {(noAccess || permissionChecked === 'notchecked') && (<NoPermissions checked={permissionChecked} />)}

                    <StyledFullScreenModal open={openViewer} onClose={() => setOpenViewer(false)} fullWidth>
                        <AssetViewer onClose={() => setOpenViewer(false)} asset={activeAsset} />
                    </StyledFullScreenModal>
                </SmartContainer>
            )}
        </App>
    )
}